import { createContext } from "react";

const qrContext = createContext();

export default qrContext;